import { Platform, usePlatform } from 'utils/hooks/usePlatform';

const platform = usePlatform();
export const getFirstPartLink = () => platform === Platform.Web ? window.location.origin : 'https://skaner.investoro.pl';
